import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Donate() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Support NeuLogic<span style={tmStyle}>™</span></h1>
      
      <section className="donate-intro">
        <h2>A Solo Journey</h2>
        <p>
          NeuLogic<span style={tmStyle}>™</span> is a solo project—just me, building desktop tools I personally want to use. 
          I keep some tools free, either because they didn't require as much development time or because I want to offer an alternative in spaces where free options already exist. All are made with care and attention to detail.
        </p>
        <p>
          I'm still learning how to share what I've built with the world, balancing my passion for creating 
          useful software with the practical realities of supporting this work.
        </p>
      </section>
      
      <section className="donate-support">
        <h2>Support the Work</h2>
        <p>
          If something I've made has helped you, and you'd like to support the continued development 
          of NeuLogic<span style={tmStyle}>™</span> tools, you can:
        </p>
        <ul>
          <li><strong>☕ Buy me a coffee</strong> – It helps offset the time I spend building, testing, and refining these tools</li>
          <li><strong>💡 Support development</strong> – Every contribution helps me improve existing tools and explore new ideas</li>
          <li><strong>🚀 Reach out about investing</strong> – If you believe in NeuLogic's long-term potential, I'm open to conversations</li>
        </ul>
        <p>
          There's no pressure—these tools will continue to exist regardless. But if you'd like to 
          support what comes next, I'd be genuinely grateful.
        </p>
      </section>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
		<a 
		  href="https://donate.stripe.com/5kQ14p4wx7vCc22f8Nebu0b"
		  className="card-btn productpage-btn-small donate-btn"
		  target="_blank"
		  rel="noopener noreferrer"
		>
		  Support NeuLogic™
		</a>
      </div>
      
      <section className="donate-contact">
        <h2>Get in Touch</h2>
        <p>
          Whether you have questions about the tools, ideas for new features, or thoughts about 
          potential collaboration, feel free to reach out at{' '}
          <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}